// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

function useResponsiveGradesStyles() {
  const isMobile = window.innerWidth <= 600;
  const isTablet = window.innerWidth > 600 && window.innerWidth <= 900;
  return {
    container: {
      maxWidth: isMobile ? "98vw" : isTablet ? 700 : 900,
      margin: isMobile ? "12px auto" : "40px auto",
      padding: isMobile ? 10 : 32,
      borderRadius: 16,
      boxShadow: "var(--ae-shadow-soft)",
      background: "var(--ae-surface)",
      border: "1px solid var(--ae-border)",
      minHeight: isMobile ? "100vh" : undefined,
      overflowX: isMobile ? "auto" : undefined,
    },
    h1: {
      color: "var(--ae-primary-strong)",
      marginBottom: 8,
      fontSize: isMobile ? 22 : 28,
    },
    p: {
      color: "var(--ae-text-muted)",
      marginBottom: 24,
      fontSize: isMobile ? 14 : 18,
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      background: "#fff",
      borderRadius: 8,
      overflow: "hidden",
      border: "1px solid var(--ae-border)",
      fontSize: isMobile ? 12 : 15,
      minWidth: isMobile ? 400 : undefined,
    },
    th: {
      padding: isMobile ? 8 : 12,
      textAlign: "left",
      color: "#ffd6ad",
      fontWeight: 700,
    },
    td: {
      padding: isMobile ? 8 : 12,
    },
    info: {
      color: "var(--ae-primary)",
      fontSize: isMobile ? 13 : 15,
      marginTop: 32,
    },
  };
}

function Grades() {
  const { user, token } = useAuth();
  const styles = useResponsiveGradesStyles(); // Fix: define styles
  const [grades, setGrades] = useState<any>([]);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>("");

  useEffect(() => {
    async function fetchGrades() {
      setLoading(true);
      setError("");
      try {
        const res = await fetch("/api/grades", {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        if (!res.ok) throw new Error("Failed to fetch grades");
        const data = await res.json();
        setGrades(data.grades || []);
      } catch (err: any) {
        setError("Could not load grades. Please try again.");
      } finally {
        setLoading(false);
      }
    }
    if (token) fetchGrades();
  }, [token]);

  if (!user) return <div style={styles.container}><h1 style={styles.h1}>Grades</h1><p style={styles.p}>Please log in to view grades.</p></div>;

  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Grades</h1>
      <p style={styles.p}>View and analyze standards-aligned grades for actionable learning insights.</p>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div style={{ color: "#dc2626" }}>{error}</div>
      ) : (
        <div style={{ width: "100%", overflowX: "auto" }}>
          <table style={styles.table}>
            <thead style={{ background: "var(--ae-primary)" }}>
              <tr>
                <th style={styles.th}>Student</th>
                <th style={styles.th}>Subject</th>
                <th style={styles.th}>Standard</th>
                <th style={styles.th}>Score</th>
              </tr>
            </thead>
            <tbody>
              {grades.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--ae-text-muted)' }}>No grades available.</td></tr>
              )}
              {grades.map((g, index) => (
                <tr key={index} style={{ background: index % 2 === 0 ? "#fff" : "var(--ae-surface-soft)" }}>
                  <td style={{ ...styles.td, color: "var(--ae-primary)" }}>{g.student}</td>
                  <td style={{ ...styles.td, color: "var(--ae-primary)" }}>{g.subject}</td>
                  <td style={{ ...styles.td, fontFamily: "monospace", fontSize: 13, color: "var(--ae-text-muted)" }}>{g.standard}</td>
                  <td style={{ ...styles.td, fontWeight: 700, color: g.score >= 85 ? "var(--ae-primary)" : g.score >= 70 ? "var(--ae-accent)" : "#000" }}>{g.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div style={styles.info}>
        <strong>What do these grades mean?</strong><br />
        <span style={{ color: "var(--ae-accent)" }}>Each score is aligned to a specific learning standard, making progress clear and actionable for all.</span>
      </div>
    </div>
  );
}

export default Grades;
